// extracted by mini-css-extract-plugin
export default {"deleteButton":"UploadWorkspaceFileDeleteButton_deleteButton__h-Tvx"};